<template>
  <div class="counter-box flex w-full md:w-6 lg:w-4">
    <div class="inner-box">
      <div class="graph-outer" :style="{ width: size + 'px', height: size + 'px', position: 'relative' }">
        <svg :width="size" :height="size" class="dial-svg">
          <circle class="dial-bg" :r="radius" :cx="center" :cy="center" :stroke="bgColor" stroke-width="3" fill="none" />
          <circle class="dial-fg" :r="radius" :cx="center" :cy="center" :stroke="fgColor" stroke-width="3" fill="none" :stroke-dasharray="circumference" :stroke-dashoffset="dashOffset" stroke-linecap="round" />
        </svg>
        <div class="inner-text count-box">
          <span class="count-text txt">{{ displayValue }}</span>
        </div>
      </div>
      <h3>{{ label }}</h3>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: Number,
    speed: {
      type: Number,
      default: 3000
    },
    fgColor: {
      type: String,
      default: '#ff4b4b'
    },
    bgColor: {
      type: String,
      default: '#ffffff'
    },
    label: String,
    size: {
      type: Number,
      default: 180
    }
  },
  data() {
    return {
      displayValue: 0,
      progress: 0,
      hasAnimated: false
    };
  },
  computed: {
    radius() {
      return (this.size - 10) / 2;
    },
    center() {
      return this.size / 2;
    },
    circumference() {
      return 2 * Math.PI * this.radius;
    },
    dashOffset() {
      return this.circumference * (1 - this.progress);
    }
  },
  mounted() {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !this.hasAnimated) {
          this.hasAnimated = true;
          this.animate();
          observer.disconnect();
        }
      },
      { threshold: 0.5 }
    );
    observer.observe(this.$el);
  },
  methods: {
    animate() {
      const start = performance.now();

      const animateFrame = (time) => {
        const elapsed = time - start;
        const fraction = Math.min(elapsed / this.speed, 1);
        this.displayValue = Math.floor(this.value * fraction);
        this.progress = fraction;

        if (fraction < 1) {
          requestAnimationFrame(animateFrame);
        } else {
          this.displayValue = this.value;
          this.progress = 1;
        }
      };

      requestAnimationFrame(animateFrame);
    }
  }
};
</script>

<style scoped>
.dial-svg {
  transform: rotate(-90deg);
  margin-bottom: 1rem;
}
.dial-bg {
  opacity: 0.2;
}
.dial-fg {
  transition: stroke-dashoffset 0.3s linear;
}
.graph-outer {
  display: inline-block;
  position: relative;
}
.counter-box {
  position: relative;
  margin-bottom: 50px;
}
.counter-box .inner-box {
  position: relative;
  text-align: center;
  width:100%
}
.inner-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  font-size: 40px;
  line-height: 180px;
  color: #3c4858;
}
.count-text {
  font-size: 38px;
  line-height: 180px;
  color: #3c4858;
  font-weight: 800;
}
.inner-box h3 {
  position: relative;
  font-size: 17px;
  line-height: 1.2em;
  color: #3c4858;
  font-weight: 600;
}
</style>
